module.exports = __webpack_public_path__ + "img/activity_51.0110035a.png";